import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/haus-white.png'
import _imports_1 from '@/assets/images/church-white.png'
import _imports_2 from '@/assets/images/rathaus-white.png'
import _imports_3 from '@/assets/images/dorf-white.png'
import _imports_4 from '@/assets/images/ghost-white.png'
import _imports_5 from '@/assets/images/karten-white.png'
import _imports_6 from '@/assets/logo/icon-512x512-round.png'



import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImgTab',
  props: ["tabName", "class", "i18nKey", "img", "disabled"],
  setup(__props) {



const t = useI18n().t;

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tab = _resolveComponent("q-tab")!

  return (_openBlock(), _createBlock(_component_q_tab, {
    name: __props.tabName,
    class: _normalizeClass(_ctx.$props.class),
    disable: __props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_avatar, {
        size: "sm",
        square: ""
      }, {
        default: _withCtx(() => [
          (__props.img === 'village')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 0,
                src: _imports_0
              }))
            : _createCommentVNode("", true),
          (__props.img === 'church')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 1,
                src: _imports_1
              }))
            : _createCommentVNode("", true),
          (__props.img === 'rathaus')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 2,
                src: _imports_2
              }))
            : _createCommentVNode("", true),
          (__props.img === 'dorf')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 3,
                src: _imports_3
              }))
            : _createCommentVNode("", true),
          (__props.img === 'ghostChat')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 4,
                src: _imports_4
              }))
            : _createCommentVNode("", true),
          (__props.img === 'karten')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 5,
                src: _imports_5
              }))
            : _createCommentVNode("", true),
          (__props.img === 'appLogo')
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 6,
                src: _imports_6
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("span", null, _toDisplayString(_unref(t)(__props.i18nKey)), 1)
    ]),
    _: 1
  }, 8, ["name", "class", "disable"]))
}
}

})